import { ContactForm } from "../../components/ContactForm";
import SEO from "../../components/SEO";
import { pageSEOData } from "../../data/seoData";
import { createMedicalBusinessSchema } from "../../utils/seo";
import "../../App.css";

const ContactPage: React.FC = () => {
  const seo = pageSEOData.contact;

  return (
    <div className="page-animation">
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        ogImage={seo.ogImage}
        structuredData={createMedicalBusinessSchema()}
      />
      <ContactForm />
    </div>
  );
};

export default ContactPage;
